export default function getHostDomain() {
  const hostname = window.location.hostname;
  if (!hostname) {
    return 'siftstaging';
  }

  const hostDomain = (hostname.split('.')[1] || '').trim().toLowerCase();
  if (!hostDomain) {
    return 'siftstaging';
  }

  return hostDomain;
}
